<!-- This is an example component -->
 <section class="w-full  flex flex-col">
    <div class="w-full p-6 relative h-[500px] bg-cover  bg-no-repeat bg-center flex flex-col justify-center "  style="background-image: url('https://www.msccruises.com/int/-/media/global-contents/homepage/carousel/fly-and-cruise-2023/fly_and_cruise_medium.jpg?bc=transparent&as=1&dmc=0&iar=0&mh=310&mw=690&sc=0&thn=0&udi=0&hash=E0451537640B2AD76E3D373557D0139F');">
        <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
        <!-- <h1 class="z-10  text-7xl text-left text-white text-shadow font-extrabold uppercase "> {{view.page?.content.name}} </h1> -->
        <h1 class="z-10  text-7xl text-left text-white text-shadow font-extrabold uppercase border-b-2 border-primary-700 max-w-128">News Bulletins</h1>
        <!-- <span class="w-60 border-b-4 border-primary-700 "></span> -->
        <p class="z-10 text-xl text-white font-light pt-2">
            Keep up to date with all the latest news direct from the cruise lines
        </p>
    </div>
    <div class="w-full grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4 md:gap-8 lg:gap-8 p-4 md:p-8 lg:p-16 xl:p-16">
        @for(blog of view.blogs; track blog) {
        <fuse-card  class="flex flex-col bg-white shadow-md border border-gray-200 mb-5">
            <a [href]="blog.link">
            <img class="" [src]="blog.imageUrl" alt="">
            </a>
            <div class="p-5">
            <a [href]="blog.link">
                <h5 class="font-bold text-2xl tracking-tight mb-2 uppercase text-accent text-center">{{ blog.title }}</h5>
            </a>
            <p class="text-gray-600 mb-3 text-center font-light">{{ blog.description }}</p>
            <p class="font-light text-primary-500 mb-3 text-center font-light">{{ blog.date }}</p>
            <div class="mx-auto flex justify-center items-center">
                <button  (click)="openModal(blog)" class="text-white mx-auto flex justify-center bg-primary-500 uppercase hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium text-sm px-6 py-2 text-center inline-flex items-center mx-auto" [href]="blog.link">
                Read more
                </button>
            </div>
            </div>
        </fuse-card>
    }
    </div>
    <app-footer-type03></app-footer-type03>
</section>
